import type { User } from '@interfaces/user';
import type { RelationUser } from '@pages/AccountDetail/newAffiliateModal';

export const generateClientNameString = (
  user: User | undefined | RelationUser | Record<string, unknown>,
  onlyFirstName?: boolean,
  onlyFirstAndLastName?: boolean,
): string => {
  if (!user || typeof user !== 'object') return '';
  if ('entityName' in user && user.entityName) return String(user.entityName);
  if (!('firstName' in user) || !user.firstName) {
    if ('id' in user && user.id) return String(user.id);
    if ('stringId' in user && user.stringId) return String(user.stringId);
    return '';
  }
  if (onlyFirstAndLastName)
    return [user.firstName, 'lastName' in user ? user.lastName : undefined]
      .filter(Boolean)
      .join(' ');
  return onlyFirstName
    ? String(user.firstName)
    : [
        user.firstName,
        'middleName' in user ? user.middleName : undefined,
        'lastName' in user ? user.lastName : undefined,
      ]
        .filter(Boolean)
        .join(' ');
};
